import { Component, Show, createMemo, createSignal } from "solid-js";
import type { TenantQuotaStatus } from "../../api/types";
import { describeQuotaStatus, quotaDismissKey } from "../../utils/quotaStatus";
import { QuotaNoticeStrip } from "./QuotaNoticeStrip";

export const QuotaBanner: Component<{
  status: TenantQuotaStatus | undefined;
}> = (props) => {
  const [dismissedKey, setDismissedKey] = createSignal<string | null>(null);
  const notice = createMemo(() =>
    props.status ? describeQuotaStatus(props.status) : null,
  );
  const key = () => (props.status ? quotaDismissKey(props.status) : null);
  const visible = () => notice() !== null && key() !== dismissedKey();

  return (
    <Show when={visible() ? notice() : null}>
      {(n) => (
        <QuotaNoticeStrip
          notice={n()}
          testId="quota-banner"
          dismissLabel="Dismiss quota notice"
          onDismiss={() => setDismissedKey(key())}
        />
      )}
    </Show>
  );
};
